import { FC, ReactNode } from 'react';
import style from './index.module.css';

export const Panel: FC<{ 
  children?: ReactNode,
}> = ({
  children
}) => {

  return (
    <div className={style.root}>
      { children }
    </div>
  )
}

export const PanelTitle: FC<{
  children?: ReactNode,
  useH4?: boolean
}> = ({
  children,
  useH4 = false
}) => {
  return useH4 ? (
    <h4 className={style.title} data-black>{children}</h4>
  ) : (
    <h3 className={style.title}>{children}</h3>
  )
}

export const PanelText: FC<{
  children?: ReactNode,
  useRender?: boolean
}> = ({
  children,
  useRender = false
}) => {

  return useRender ? (
    <div
      className={style.text}
      dangerouslySetInnerHTML={{
        __html: `<p>${children}</p>`
      }}
    />
  ) : (
    <div className={style.text}>{children}</div>
  )
}

export const PanelList: FC<{
  items: string[]
}> = ({
  items
}) => {
  return (
    <ul className={style.list}>
      {items.map((item, index) => (
        <li key={index}>{index + 1}. {item}</li>
      ))}
    </ul>
  )
}

export const PanelNotice: FC<{
  children?: ReactNode
}> = ({ children }) => {

  return (
    <div className={style.notice}>
      { children }
    </div>
  )
}